/* eslint-disable */

export enum AttributeType {
	Select = 0,
	AttributeFilter = 1,
	Input = 2,
	NumericInput = 3,
	Image = 4,
	
}
